import { MortgageCalculator } from "@component/Mortgage/Calculator/MortgageCalculator";
import { CsokPlusComponent } from "@landing/components/CsokPlusComponent";
import { LandingAccordion } from "@landing/components/LandingAccordion";
import { LandingBottom } from "@landing/components/LandingBottom";
import { LandingContainer } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";
import { Accordion, Col, Row } from "react-bootstrap";

/**
 * @Routing
 *
 * @title "Keresd meg a legkedvezőbb építési hitelt!"
 * @description "Hasonlítsd össze a magyar bankok építési hiteleit a Bankmonitor hitelkalkulátorával!✔️14 bank speciális jelzáloghitelei építkezőknek✔️"
 * @route "/epitesi-hitel/"
 */
export default class Landing extends React.PureComponent {
	public render(): ReactNode {
		return (
			<>
				<MortgageCalculator
					title="Építési hitel kalkulátor"
					description="10 magyar bank építési hitele egy helyen: spórolj milliókat egy jó döntéssel!"
					button="Építési hitelek keresése"
					variant="EPITES"
				/>
				<CsokPlusComponent />
				{this.renderFaq()}
				<LandingBottom tags="lakashitel" />
			</>
		);
	}

	private renderFaq(): ReactNode {
		return (
			<LandingContainer id="gyakori-kerdesek" sendEvent size="lg">
				<Row className="justify-content-center">
					<Col md="10">
						<h2 className="h1 mb-lg-4 mb-md-3 mb-2 text-center">Gyakran ismételt kérdések</h2>
						<Accordion>
							<LandingAccordion title="Milyen célra igényelhetünk építési hitelt?">
								<p>
									Az építési hitel a{" "}
									<a href="/lakashitel-kalkulator/?link_type=landing-faq">lakáshitel</a> egy speciális
									fajtája, melyből családi ház, lakás építését finanszírozhatod meg. A kölcsön
									fedezete a felépülő ingatlan, ugyanakkor a hitel teljes összegét a tervek alapján a
									felépülő ház jövőbeni értéke alapján határozza meg a bank. Vagyis akár az{" "}
									<strong>ingatan jelenlegi értékénél jóval nagyobb összeget</strong> kaphatsz az
									építkezésre.
								</p>
							</LandingAccordion>
							<LandingAccordion title="Finanszírozható szabad felhasználású hitelből egy építkezés?">
								<p>
									Akár szabad felhasználású jelzáloghitelt is igényelhetsz az építési munkálatok
									befejezésére. Ebben az esetben azonban az építési telek – építés megkezdését
									megelőző igénylés esetén – értéke alapján határozzák meg az adható összeget. Ha már
									megkezdődött az építkezés, akkor még kevesebb lehet az igényelhető összeg, mivel a
									félig kész épület bontási költségeit is figyelembe veszi a pénzintézet.
								</p>
								<p>
									<a href="/szemelyi-kolcson/?link_type=landing-faq">Személyi kölcsönből</a>{" "}
									finanszírozhatod az építési munkálatokat. Ehhez nincs szükség ingatlanfedezetre,
									ugyanakkor a konstrukció kamata magasabb, mint egy építési hitelé. Ráadásul egy
									személyi kölcsön összege legfeljebb 10 millió forint lehet, ez pedig sok esetben nem
									fedezi egy házépítés költségeit.
								</p>
							</LandingAccordion>
							<LandingAccordion title="Mennyi építési hitelt kaphatunk?">
								<p>
									A fedezeti ingatlan – ez a legtöbb esetben az épülő lakás, ház –{" "}
									<strong>
										jövőbeni forgalmi értékének legfeljebb a 80 százalékához juthatsz hozzá
									</strong>{" "}
									építési hitelből, ami nem alku kérdése, ez ugyanis jogszabályi korlát. Vagyis az
									elkészült ház értékéből indul ki a bank. Számos pénzintézet azonban szigorúbb
									szabályokat alkalmaz a jogszabályi korlátnál, ami miatt viszont már fontos lehet a
									megfelelő bank kiválasztása.
								</p>
							</LandingAccordion>
							<LandingAccordion title="Mit építhetünk építési hitelből?">
								<p>
									A felépített ingatlannak komfortosnak kell lennie, anélkül nem lehet fedezet.
									Jellemzően elvárás, hogy legyen benne fürdő, wc és főzőhelyiség, valamint a fűtés, a
									vízellátás és a szennyvíz elvezetése legyen megoldott.
								</p>
								<p>
									Az ingatlan végleges forgalmi értékének el kell érnie egy meghatározott szintet. Ez
									jellemzően 5-6 millió forint, ami újépítésű ingatlanok esetében nem szokott gondot
									okozni.
								</p>
								<p>
									Speciális elvárás lehet magára az építési telek minimális árára vonatkozóan is: nem
									minden bank szeretne ugyanis alacsony értékű telekre épített lakást
									megfinanszírozni.
								</p>
							</LandingAccordion>
							<LandingAccordion title="Egy összegben folyósítja a bank az építési hitelt?">
								<p>
									<strong>
										Az elvégzett építési munkálatokkal arányosan, szakaszosan kapod meg a
										hitelösszeget
									</strong>
									. A szakaszok meghatározásánál a pénzintézet fontosnak tartja, hogy az ingatlan –
									aktuális készültségi fokon – mindig elbírja a kifolyósított hitelösszeget.
									Jellemzően a bank a kölcsönt 2, 3, vagy 4 részletben folyósítja számodra.
								</p>
							</LandingAccordion>
							<LandingAccordion title="Mi a feltétele az egyes részletek kifolyósításának?">
								<p>
									Minden részletnél elvárás, hogy az építkezés{" "}
									<strong>elérje az elvárt készültségi fokot</strong>, ezt helyszíni szemlével –
									értékbecslés – fogja ellenőrizni minden esetben a pénzintézet.
								</p>
								<p>
									Az első részlet lehívásához a betervezett saját megtakarítás – önerő – beépítése
									szükséges a készültségi szint eléréséhez. Az utolsó részletnél jellemzően a
									pénzintézet elvárja a használatbavételi engedély, vagy annak megfelelő dokumentum
									meglétét.
								</p>
							</LandingAccordion>
							<LandingAccordion title="Könnyűszerkezetes ingatlan építésére is fel lehet venni építési hitelt?">
								<p>
									Ezt nem tiltják a banki szabályok. Ugyanakkor a könnyűszerkezetes ingatlanok
									építésére igényelt hitelt is szakaszosan folyósítanák a bankok. Márpedig az ilyen
									ingatlanok – már a könnyűszerkezet jellegéből adódóan is – igen gyorsan elkészülnek.
								</p>
								<p>
									Sok esetben a <strong>bankok számára a szakaszolás jelent problémát</strong>, és ez
									okozhat nehézséget a hitelfelvétel során. A legtöbb pénzintézet azonban nem zárkózik
									el kategorikusan a könnyűszerkezetes ingatlanok építésének megfinanszírozásától, így
									érdemes körüljárni a lehetőségeket.
								</p>
							</LandingAccordion>
							<LandingAccordion title="Mekkora önerő kell egy építési hitelhez?">
								<p>
									Jogszabályi előírás alapján az elkészült lakás{" "}
									<strong>
										jövőbeni forgalmi értékének legfeljebb a 80 százalékát veheted fel hitelként
									</strong>
									. Ettől azonban sok esetben az egyes pénzintézetek szigorúbb irányba eltérnek.
								</p>
								<p>
									Ez nem azt jelenti, hogy a költségvetés – építési költségek – 80 százalékát kapod
									meg, hiszen az elkészült ingatan várható teljes értéke ezt alapesetben meghaladja.
									Azonban az sem helyes megközelítés, ha a telekárhoz hozzáadod az építési
									költségeket. Ha előreláthatóan szűkösen lesz meg az önerő, akkor érdemes előzetesen
									felbecsültetni az épülő lakás várható értékét.
								</p>
							</LandingAccordion>
							<LandingAccordion title="Önerő nélkül, kizárólag hitelből is megfinanszírozható az építkezés?">
								<p>
									Akár megtakarításod felhasználása nélkül - önerő nélkül – is megfinanszírozhatod új
									házad felépítését.
								</p>
								<p>Erre az alábbi két lehetőséged lenne:</p>
								<ul>
									<li>
										<strong>Pótfedezet bevonásával</strong>: a felépülő ingatlan mellett egy másik
										lakást, házat is felajánlhatsz fedezetként, megnövelve ezzel a felvehető hitel
										összegét. Hiszen a két ingatlan együttes értékének 80 százalékába – vagy a bank
										által meghatározott szigorúbb rátába – kell beleférnie a hitelösszegnek.
									</li>
									<li>
										Mivel az épülő ingatlan jövőbeni értéke – elkészült ház, lakás várható értéke –
										alapján határozza meg a bank az adható hitelösszeget, amennyiben{" "}
										<strong>a telek értéke nagy volt</strong>, melyre egy relatív kisebb értékű
										felépítményt építenél, akkor a várható forgalmi érték akár a teljes építési
										költséget elbírhatja.
									</li>
								</ul>
								<p>
									Építési hitelből a költségvetésnél nagyobb összeget nem vehetsz fel, az adható
									összeget emellett még a jövedelmed is befolyásolja. Ugyanis a törlesztőrészletet a
									fizetésednek el kell bírnia.
								</p>
							</LandingAccordion>
							<LandingAccordion title="Mennyi hitelt kaphatsz a jövedelmed alapján?">
								<p>
									Az igényelhető hitelösszeg természetesen függ a jövedelmedtől, hiszen a havi
									bevételeidből ki kell fizetned kölcsön törlesztőrészletét is. Az{" "}
									<a href="/jobb-tudni/babavaro/?link_type=landing-faq#jovedelemaranyos-torlesztoreszlet-mutato-jtm">
										adósságfék szabályok
									</a>{" "}
									maximalizálják, hogy a jövedelmed mekkora részét fordíthatod a kölcsön részleteire.
									Fontos, hogy ez csupán jogszabályi korlát, ettől szigorúbb irányba a bankok
									eltérhetnek, ráadásul a kalkuláció során a meglévő törlesztőrészleteket,
									hitelkereteket is figyelembe veszik a pénzintézetek.
								</p>
							</LandingAccordion>
							<LandingAccordion title="A meglévő hitelek törlesztői is befolyásolják, hogy mennyi hitelt kapok?">
								<p>
									Igen, az felvenni kívánt kölcsön havi törlesztőrészletének és a meglévő kölcsönökre
									fizetendő havi részleteknek együttesen kell beleférniük a jövedelem
									terhelhetőségébe. Azaz nem haladhatja meg az így kikalkulált összeg az igazolt nettó
									jövedelmed egy meghatározott százalékát.
								</p>
								<p>
									Sőt, a számítás során a meglévő hitelkeretek - folyószámlahitel, hitelkártya –{" "}
									<strong>teljes keretének 5 százalékát is törlesztőrészletnek tekintik</strong>{" "}
									függetlenül attól, hogy a keretből mekkora összeg van épp aktuálisan kihasználva.
								</p>
							</LandingAccordion>
							<LandingAccordion title="Milyen jövedelem mellett érdemes megigényelni az építési hitelt?">
								<p>
									Van egy igazol jövedelemszint, ami alatt az egyes pénzintézetek nem is foglalkoznak
									a hitelügyleteddel. Jellemzően legalább a{" "}
									<strong>minimálbérnek megfelelő havi bevétellel</strong> szükséges rendelkezned, ez
									az összeg azonban gyakran nem elégséges a szükséges hitelösszeg felvételéhez, a
									hitelkérelem beadásához azonban már elégséges lehet.
								</p>
								<p>
									Fontos, hogy a minimálisan elvárt bevételt önállóan elfogadható – elsődleges –
									jövedelemből kell produkálnod.
								</p>
								<p>A bankok ugyanis a különböző jövedelmeket jellemzően három kategóriába sorolják:</p>
								<ul>
									<li>
										<strong>Önállóan elfogadható jövedelem</strong>: ezek azok a bevételek, amelyek
										mellé nem szükséges más bevételi forrás. Ilyen tipikusan az alkalmazotti
										munkabér, a vállalkozói bevételek, vagy a nyugdíj.
									</li>
									<li>
										<strong>Önállóan nem elfogadható – másodlagos – jövedelmek</strong>: ezek mellé
										mindenképpen szükséges egy a minimális elvárásoknak megfelelő bevételi forrás
										is. Ilyen tipikusan az osztalék bevétel, bérleti díjból származó bevétel, a GYES
										és a GYED.
									</li>
									<li>
										<strong>Nem elfogadható jövedelmek</strong>: azok a bevételek kerülnek ide,
										amelyekkel a bank a hitelbírálat során nem számol. Ilyen például a munkanélküli
										segély, vagy épp a közfoglalkoztatottak jövedelme.
									</li>
								</ul>
							</LandingAccordion>
							<LandingAccordion title="Milyen hosszú munkaviszonyra van szükség építési hitel igényléséhez?">
								<ol>
									<li>
										A bankok jellemzően legalább <strong>három hónapos</strong> határozatlan idejű
										alkalmazotti munkaviszonyt várnak el.
									</li>
									<li>
										Határozott munkaszerződés esetében azonban a feltételek szigorodhatnak:
										<ul>
											<li>Legalább 6-12 hónapos folyamatos munkaviszonyt várnak el.</li>
											<li>
												Jellemzően a foglalkoztatási periódusra is van egy minimális 6-12
												hónapos elvárás.
											</li>
											<li>
												Több pénzintézet azt is elvárja, hogy legalább a második periódust
												kezdje meg a munkavállaló a cégnél. (Vagyis a szerződést egyszer már
												meghosszabbították.) Ez gyakran kiváltható egy céges
												szándéknyilatkozattal arról, hogy hosszabbítani kíván majd.
											</li>
										</ul>
									</li>
									<li>
										Vállalkozók esetében sokszor elvárás, hogy rendelkezzen legalább egy teljes
										lezárt üzleti évvel. Ez azt jelenti, hogy ha egy vállalkozás 2020 folyamán
										indult, akkor legkorábban 2022-től lesz hitelképes.
									</li>
								</ol>
							</LandingAccordion>
							<LandingAccordion title="Milyen feltételekkel fogadható el a kismamák jövedelme?">
								<p>
									Várandós nők, kismamák jövedelmét a legtöbb bank korlátozással fogadja el. Sok
									esetben az{" "}
									<strong>
										aktuális fizetésnek csak egy meghatározott százalékával – például 70% -
										kalkulálnak
									</strong>{" "}
									az adható hitelösszeg megállapítása során.
								</p>
								<p>
									Sok esetben a kismamák jövedelmét nem fogadja el önállóan a pénzintézet. Vagy az
									anyukának kell másik önállóan elfogadható bevétellel rendelkeznie, vagy egy
									megfelelő jövedelemmel rendelkező társigénylőnek – jellemzően a férj, élettárs – is
									be kell kerülnie a hitelügyletbe.
								</p>
							</LandingAccordion>
							<LandingAccordion title="Igényelhető csok támogatás építésre?">
								<p>
									A{" "}
									<strong>
										családi otthonteremtési kedvezmény (
										<a href="/csok-feltetelei/?link_type=landing-faq">csok támogatás</a>) egy vissza
										nem térítendő lakáscélú támogatás
									</strong>
									, melyet a gyermekek – meglévő és vállalt – után igényelhetsz. A támogatást lakás,
									lakóház építésére is igényelheted.
								</p>
								<p>
									Egy gyermek esetén 600 ezer, két gyermek esetén 2,6 millió, míg három gyermek esetén
									10 millió forint támogatást igényelhetsz az építési munkálatok megfinanszírozására.
									A meglévő és vállalt gyermekek is számítanak a támogatás során. (Vállalt gyermekre
									támogatást azonban csak házaspárok igényelhetnek, melyeknek egyig tagja sem töltötte
									be a 40. életévét.)
								</p>
								<p>
									A csok támogatást jellemzően a bankok elfogadják önerőként, amennyiben meglévő
									gyermekeidre igényled a konstrukciót. Vagyis a kapott összeggel csökkenthető az
									építkezéshez szükséges saját megtakarítás nagyságát.
								</p>
							</LandingAccordion>
							<LandingAccordion title="Milyen speciális dokumentumokra van szükség építési hitel igényléséhez?">
								<p>
									A személyazonostáshoz szükséges okmányok és a jövedelmet alátámasztó igazolások
									mellett van néhány speciális dokumentum, melyet építési hitelek esetén szüksége
									bemutatni
								</p>
								<ul>
									<li>
										<strong>Tulajdoni lap és térképmásolat</strong>: ezeket szükséges benyújtani az
										építés helyéül szolgáló ingatlanról is.
									</li>
									<li>
										<strong>
											Építési engedély dokumentáció (építési engedély, műszaki leírás, tervrajz)
										</strong>
										: ebből láthatja a bank, hogy mire használnád fel a kért hitelösszeget, valamint
										azt, hogy várhatóan mennyit fog érni a tervezett ingatlan.
									</li>
									<li>
										<strong>Műszaki, vezető/kivitelező által ellenjegyzett költségvetés</strong>: ez
										tartalmazza tételesen a tervek alapján felépülő ingatlan részletes költségeit.
									</li>
									<li>
										<strong>Kivitelezővel kötött megállapodás</strong>: ez abban az esetben
										szükséges, ha generálkivitelezőt bízol meg az építkezés során.
									</li>
									<li>
										<strong>Ráépítési megállapodás</strong>: ez abban az esetben szükséges, ha a
										telek jelenlegi tulajdonosa más, mint a felépítmény jövőbeni tulajdonosa.
										(Például a szülői telekre – ház mellé – építkeznél.)
									</li>
								</ul>
							</LandingAccordion>
							<LandingAccordion title="Létezik támogatott építési hitel?">
								<p>
									Nem kell lemondani a kamattámogatásról sem csak azért, mert építkezel. A{" "}
									<a href="/csok/?link_type=landing-faq">csok hitel</a> melynek{" "}
									<strong>kamata a futamidő végéig fix 3%</strong> - igényelhető építési célra is. A
									feltétel csupán az, hogy legalább 2 gyermekre igényeld a csok támogatást is.
								</p>
								<p>
									A hitel maximális összege 10 millió forint, amennyiben két gyermekre veszed fel a
									csok támogatást, illetve 15 millió forint, ha három, vagy több gyermek után kérted a
									családi otthonteremtési kedvezményt.
								</p>
								<p>
									Ha nem lenne elégséges az építési költségekre a csok támogatás és a csok hitel,
									akkor még igényelhetsz piaci kamatozású építési hitelt is, amennyiben a fedezet és a
									jövedelmed elbírja a hitelösszeget, törlesztőrészletet.
								</p>
							</LandingAccordion>
							<LandingAccordion title="A Babaváró hitel felhasználható lakóház építésére?">
								<p>
									A <a href="/babavaro-hitel/?link_type=landing-faq">Babaváró hitel</a> szabad célú
									kölcsön, így az építési költségek megfinanszírozására is fordítható. A konstrukció a
									teljes futamidő alatt kamatmentes, amennyiben egy gyermek születik 5 éven belül. A
									második baba születésekor a tartozás 30 százalékát, míg a harmadik baba érkezésekor
									a teljes tartozást elengedik.
								</p>
								<p>
									Ráadásul a <strong>felvett összeg 75%-a támogatásnak minősül</strong>, azaz
									helyettesítheti az építkezéshez minimálisan szükséges saját megtakarítást.
								</p>
							</LandingAccordion>
							<LandingAccordion title="Mely bankok kínálnak építési hitelt?">
								<p>A legtöbb hazai banknál igényelhető építési hitel:</p>
								<ul>
									<li>CIB Bank</li>
									<li>ERSTE Bank</li>
									<li>K&H Bank</li>
									<li>MBH Bank</li>
									<li>OTP Bank</li>
									<li>UniCredit Bank</li>
								</ul>
							</LandingAccordion>
						</Accordion>
					</Col>
				</Row>
			</LandingContainer>
		);
	}
}
